import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { api, UnauthorizedError } from "@/lib/api";

export function RequireAuth(): JSX.Element {
  const location = useLocation();
  const me = useQuery({
    queryKey: ["auth", "me"],
    queryFn: api.me,
    retry: false,
    staleTime: 5 * 60_000,
  });

  if (me.isPending) {
    return (
      <div className="grid h-screen w-screen place-items-center bg-paper">
        <span className="text-data text-ink-3">
          Caricamento…
        </span>
      </div>
    );
  }
  if (me.isError) {
    if (me.error instanceof UnauthorizedError) {
      const next = encodeURIComponent(location.pathname + location.search);
      return <Navigate to={`/login?next=${next}`} replace />;
    }
    return (
      <div className="grid h-screen w-screen place-items-center bg-paper">
        <span className="text-sm text-destructive">Errore di connessione al server.</span>
      </div>
    );
  }
  return <Outlet />;
}
